import apiUrl from "./config/config";
import axios from "axios";

class productTypeApi {

  static async getProductTypes(params)
  {

    try
    {

      const response = await axios(apiUrl + "productType", {params});

      return response.data;

      // while(true){

      //   const response = await axios(apiUrl + "productType", {params});

      // }

    } catch (err)
    {

      throw new Error();

    }

  }

  static async getProductType(id = "")
  {

    try
    {

      const response = await axios(apiUrl + "productType/" + id);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

}







export default productTypeApi;
